/**
 * Generated by orval v6.16.0 🍺
 * Do not edit manually.
 * Neubie Order
 * Neubie Order API Server
 * OpenAPI spec version: V1
 */

export type AppVersionsNeedUpdateRetrieveDeviceType =
  (typeof AppVersionsNeedUpdateRetrieveDeviceType)[keyof typeof AppVersionsNeedUpdateRetrieveDeviceType]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AppVersionsNeedUpdateRetrieveDeviceType = {
  IOS: 'IOS',
  ANDROID: 'ANDROID'
} as const
